export class QuickNote {
  note: string
  ownerType: string
  ownerId: number
}
